module.exports = __webpack_public_path__ + "static/media/zheng.bc98f483.png";


//////////////////
// WEBPACK FOOTER
// ./src/identityVerification/modules/papersUpload_GR/image/zheng.png
// module id = 1093
// module chunks = 0